import { keepPreviousData, useQuery } from '@tanstack/react-query';

import useLastRefreshedAt from '@/common/hooks/useLastRefreshedAt';
import { createDefaultPaginated } from '@/common/types/paginated';
import { omitEmpty } from '@/common/utils/ObjectFormatters';
import {
  fetchPaginatedPoliciesSummary,
  PaginationParams,
  PolicyFilters,
  PolicySummary,
} from '@/policy/api/FetchPolicyList';

export const useFetchPaginatedPoliciesSummary = (
  pagination: PaginationParams,
  filters?: PolicyFilters,
) => {
  const normalizedFilters = omitEmpty(filters);

  const { data, isLoading, error, refetch, dataUpdatedAt } = useQuery({
    queryKey: ['policies', pagination, normalizedFilters],
    queryFn: ({ signal }) =>
      fetchPaginatedPoliciesSummary(pagination, normalizedFilters, signal),
    throwOnError: true,
    placeholderData: keepPreviousData,
    refetchInterval: 30000,
  });

  const lastRefreshedAt = useLastRefreshedAt(dataUpdatedAt);

  const paginatedPolicies = data || createDefaultPaginated<PolicySummary>();

  return {
    paginatedPolicies,
    isLoading,
    error,
    refetch,
    lastRefreshedAt,
  };
};
